const iban = {
  iban: 'IBAN Number',
  ibanTitle: 'Please enter your IBAN Number',
  ibanLabel:
    'Please enter the policyholder’s IBAN. This IBAN will not be used for charging or payments — it is only used for potential refunds after the policy is issued.',
  addIban: 'Add IBAN',
  noIbansFound: 'No IBANs found',
  startsWithSA: 'Starts with SA',
  includesBankIdentifierCode: 'Include bank identifier code',
  ibanTotalNumber: 'Total 22 Numbers',
  ibanDrawerTitle: 'Please enter your IBAN Number',
  ibanDrawerSubtitle:
    'Please enter the policyholder’s IBAN. This IBAN will not be used for charging or payments — it is only used for potential refunds after the policy is issued.',
  ibanAddedSuccessfully: 'IBAN added successfully',
}

export default iban
